<template>
	<Layout :hideCreatePrescriptionBtn="true">
		<div class="container" style="max-width:480px;">
			
			<div class="card mb-3" v-if="canDispense">
				<div class="card-body" v-if="!prescription">
					<div class="label">BUSCAR PRESCRIPCIÓN</div>
					<div class="text-center">
						<img src="@/assets/img/search-user.png" />
					</div>

					<div class="mt-3 d-flex">
						<div class="btn btn-primary btn-qr" @click="$refs.barcodeReader.open()">
							<i class="fa fa-qrcode"></i>
						</div>
						<input type="text" class="form-control ml-1 mr-1" placeholder="Código" v-model="searchTerms" />

						<div class="btn btn-primary" @click="search()">
							<span v-if="loading">Buscando</span>
							<span v-if="!loading">Buscar</span>
						</div>
					</div>

					<div class="alert alert-warning mt-2 text-center" v-if="prescriptionNotFound">
						No se ha encontrado una prescripción habilitada con el código ingresado
					</div>
				</div>

				<div class="card-body" v-if="prescription">
					<!-- <div class="label">DISPENSAR</div> -->
					<FormulateForm name="formDispense" v-model="form" @submit="dispense">
						<div class="row row-xs">
							<div class="col-6">
								<PatientCard :id="prescription.patient.id" />
							</div>
							<div class="col-6">
								<MedicCard :id="prescription.medic.id" />
							</div>
						</div>
						<hr />
						<ProductCard
							:product="prescription.product"
							:qty="prescription.qty"
							:expireAt="prescription.expireAt"
							:indications="prescription.indications"
						/>

						<p class="text-sm">
							<strong>Administración:</strong><br>
							{{prescription.dosage}}
						</p>


						<hr />

						<div class="d-flex mt-3 justify-content-between align-items-center">
							<FormulateInput
								v-model="isSubstitute"
								type="checkbox"
								label="Entregar sustituto?"
								class="m-0"
							/>

							<div v-if="isSubstitute" style="width: 250px;">
								<ProductSearch @selected="substituteSelected" />
								<!-- <FormulateInput
									name="substitute"
									:options="similaryProducts"
									type="select"
									:validation="isSubstitute ? 'required' : null"
								/> -->
								<!-- {{form.substitute}} -->
							</div>
						</div>

						<hr />

						<!-- <div class="d-flex mt-3">
							<div class="mr-1">
								<FormulateInput
									label="Número de lote"
									name="loteNumber"
									type="number"
									validation-name="Número de lote"
									validation="required"
								/>
							</div>
							<div class="">
								<FormulateInput
									label="Fecha de vencimiento"
									name="loteExpireAt"
									type="date"
									validation-name="Vencimiento"
									validation="required"
									:min="today"
								/>
							</div>
						</div> -->

						<!-- <hr /> -->

						<div class="section-title mt-4 mb-2">Entregar a:</div>

						<div class="d-flex justify-content-between align-items-center">
							<div class="section-title mb-2 ">
								{{ this.form.dispensedToName }} {{ this.form.dispensedToLastname }} <br />
								
								<span v-if="this.form.dispensedToDocumentText">{{ this.form.dispensedToDocumentText }} <br /></span>
								<span v-if="this.form.dispensedToAddressStreet">{{ this.form.dispensedToAddressStreet }} <br /></span>
								<span v-if="this.form.dispensedToAddressCity">{{ this.form.dispensedToAddressCity }}, {{ this.form.dispensedToAddressCountryName }}</span>
								
							</div>
							<div>
								<div class="btn btn-xs btn-light" @click="$refs.dispenseToModalForm.open()">
									Cambiar
								</div>
							</div>
						</div>

						<hr />

						<div class="d-flex justify-content-between align-items-center">
							<div>
								<div class="section-title mt-4 mb-2">Entregado por:</div>
								<div class="section-title mt-4 mb-2 text-right" v-if="form.dispensedBy">
									{{ form.dispensedBy.name }}
								</div>
							</div>
							<div>
								<div class="btn btn-xs btn-light" @click="$refs.pharmacyDispenserModalForm.open()">
									Cambiar
								</div>
							</div>
						</div>

						<FormulateErrors />
					</FormulateForm>
				</div>
			</div>

			<div
				v-if="canCreate && canDispense"
				class="btn btn-primary btn-block btn-lg"
				:class="{ disabled: !canCreate }"
				@click="$formulate.submit('formDispense')"
			>
				 Dispensar
			</div>
 
			<div class="card mb-3" v-if="!canDispense">
				<div class="card-body" >
					<div class="alert alert-warning text-center">
						Farmacia inhabilitada para dispensar
					</div>
				</div>
			</div>
					


		</div>

		<PharmacyDispenserModalForm ref="pharmacyDispenserModalForm" @upserted="dispenserSelected" />
		<DispenseToModalForm ref="dispenseToModalForm" @upserted="dispenseToSelected" />
		<BarcodeReader ref="barcodeReader" @readed="readedBarcode" />
	</Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import gql from "graphql-tag"
import ProductCard from "@/views/products/ProductCard"
import PatientCard from "@/views/patients/PatientCard"
import MedicCard from "@/views/medics/MedicCard"
import PharmacyDispenserModalForm from "@/views/account/PharmacyDispenserModalForm"
import DispenseToModalForm from "./DispenseToModalForm"
import BarcodeReader from "@/components/BarcodeReader"
import ProductSearch from "../../components/ProductSearch"

export default {
	name: "PrescriptionDone",
	components: { ProductCard, PatientCard, PharmacyDispenserModalForm, DispenseToModalForm, MedicCard, BarcodeReader, ProductSearch },
	data() {
		return {
			searchTerms: null,
			prescription: null,
			loading: false,
			prescriptionNotFound: false,
			today: this.$moment().format("YYYY-MM-DD"),
			isSubstitute: false,
			form: {
				loteNumber: '0000',
				loteExpireAt: '2050-01-01',
				substitute: "N",
				dispensedToName: null,
				dispensedToLastname: null,
				dispensedToDocument: {
					type: "UY",
					number: null
				},
				dispensedToAddressCountry: "226",
				dispensedToAddressCountryName: "Uruguay",
				dispensedToAddressCity: null,
				dispensedToAddressStreet: null,
				dispensedBy: JSON.parse(localStorage.getItem("lastDispenser")) || { id: null, name: null }
			},
			similaryProducts: {},
			
		}
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedPharmacy']),
		canCreate: function() {
			return this.prescription ? true : false
		},
		canDispense: function() {
			return this.loggedPharmacy && this.loggedPharmacy.status == 'ACTIVE' ? true : false
		}
	},

	async beforeMount() {
		this.loading = false
	},
	methods: {
		substituteSelected(selected){
			this.form.substitute = selected.id
		},

		readedBarcode(barcode) {
			console.log(barcode)
			this.searchTerms = barcode
			this.search()
		},

		search() {
			if (!this.loading) {
				this.loading = true
				this.prescriptionNotFound = false
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $code: String!, $status: String!) {
								prescriptions(take: $take, skip: $skip, code: $code, status: $status) {
									data {
										id
										
										dosage
										product {
											id
											type
											name
										}
										medic {
											id
										}
										patient {
											id
											name
											lastname
											document {
												type
												number
											}
											documentText
											address {
												country {
													id
													name
												}
												city
												street
											}
										}
										expireAt
									}
								}
							}
						`,
						variables: {
							take: 1,
							skip: 0,
							code: this.searchTerms,
							status: "AVAILABLE"
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						if (data.prescriptions.data && data.prescriptions.data.length == 1) {
							this.prescription = data.prescriptions.data[0]
							console.log("this.prescription", this.prescription)

							this.form.dispensedToName = this.prescription.patient.name
							this.form.dispensedToLastname = this.prescription.patient.lastname
							this.form.dispensedToDocumentText = this.prescription.patient.documentText
							this.form.dispensedToDocument = {
								type: this.prescription.patient.document.type,
								number: this.prescription.patient.document.number
							}
							this.form.dispensedToAddressCountry = this.prescription.patient.address.country.id
							this.form.dispensedToAddressCountryName = this.prescription.patient.address.country.name
							this.form.dispensedToAddressCity = this.prescription.patient.address.city
							this.form.dispensedToAddressStreet = this.prescription.patient.address.street
						} else {
							this.prescriptionNotFound = true
						}

						this.getSubsituteProduct()
						this.loading = false
					})
					.catch(() => {
						this.loading = false
					})
			}
		},

		dispense() {
			this.$formulate.handle({ formErrors: null }, "formDispense")

			if (!this.form.dispensedBy || !this.form.dispensedBy.id) {
				this.$formulate.handle({ formErrors: ["Debe seleccionar un usuario dispensador"] }, "formDispense")
				return
			}
			console.log(this.form)
			//valido que esten todos los datos de quien recibe.
			if (
				!this.form.dispensedToName ||
				!this.form.dispensedToLastname ||
				!this.form.dispensedToDocument
			) {
				this.$formulate.handle({ formErrors: ["Debe completar los datos de quien retira"] }, "formDispense")
				return
			}

			if (!this.saving) {
				this.saving = true

				let dataInput = {
					prescription: this.prescription.id,
					product: this.prescription.product.id,
					productType: this.prescription.product.type,

					substitute: this.isSubstitute ? this.form.substitute : "N",

					loteNumber: this.form.loteNumber,
					loteExpireAt: this.form.loteExpireAt,

					dispensedToName: this.form.dispensedToName,
					dispensedToLastname: this.form.dispensedToLastname,
					dispensedToDocument: this.form.dispensedToDocument,
					dispensedToAddressCountry: this.form.dispensedToAddressCountry,
					dispensedToAddressCity: this.form.dispensedToAddressCity,
					dispensedToAddressStreet: this.form.dispensedToAddressStreet,

					dispensedBy: this.form.dispensedBy.id
				}

				console.log(dataInput)

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: DispensationInput!) {
								dispensationCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data: dataInput
						}
					})
					.then(() => {
						this.$toast.success("Dispensación creada correctamente")
						this.searchTerms = null
						this.prescription = null
						this.saveLastDispenser(this.form.dispensedBy)
						this.form = {
							loteNumber: null,
							loteExpireAt: null,
							substitute: "N",
							dispensedToName: null,
							dispensedToLastname: null,
							dispensedToDocument: {
								type: "UY",
								number: null
							},
							dispensedToAddressCountry: "226",
							dispensedToAddressCity: null,
							dispensedToAddressStreet: null,
							dispensedBy: JSON.parse(localStorage.getItem("lastDispenser")) || { id: null, name: null }
						}
						this.saving = false
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.saving = false
					})
			}
		},

		dispenserSelected(data) {
			this.form.dispensedBy = data
		},
		saveLastDispenser(dispenser) {
			localStorage.setItem("lastDispenser", JSON.stringify(dispenser))
		},
		dispenseToSelected(data) {
			console.log("dispenseToSelected", data)

			this.form.dispensedToName = data.dispensedToName
			this.form.dispensedToLastname = data.dispensedToLastname
			// this.form.dispensedToDocumentText = data.dispensedToDocumentText
			// this.form.dispensedToDocument = {
			// 	type: data.dispensedToLastname.type,
			// 	number: data.dispensedToLastname.number
			// }
			this.form.dispensedToAddressCountry = data.dispensedToAddressCountry
			this.form.dispensedToAddressCountryName = data.dispensedToAddressCountryName
			this.form.dispensedToAddressCity = data.dispensedToAddressCity
			this.form.dispensedToAddressStreet = data.dispensedToAddressStreet

			// this.form.dispensedBy = data
		},

		getSubsituteProduct(){
			console.log("getSubsituteProduct")
			console.log(this.prescription.product.id)
			if(this.prescription.product){
				
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $sameGroupAs: String) {
								products(take: $take, skip: $skip, sameGroupAs: $sameGroupAs) {
									data {
										id
										type
										name
										labName
										substances {
											name
											dosif
											unit
										}
										dosificationUnit
										dosificationType
									}
									pageInfo {
										totalItems
									}
								}
							}
						`,
						variables: {
							take: 10,
							skip: 0,
							sameGroupAs: this.prescription.product.id
						},
						fetchPolicy: "no-cache"
					})
					.then(data => {
						// convert array to object key value
						this.similaryProducts = data.data.products.data.reduce((obj, item) => {
							obj[item.id] = item.name
							return obj
						}, {})						
					})
			}

			

		}
	}
}
</script>

<style scoped>
.btn-qr {
	padding: 4px 12px;
	font-size: 20px;
}
</style>
